import { Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import ButtonCustom from 'src/components/form/Button'
import {
  APP_SQ_ENDPOINT_JS,
  SQ_APPLICATION_ID,
  SQ_LOCATION_ID,
} from 'src/constants/env-constant'
import useScript from 'src/hook/useScript'
import { useAppDispatch, useAppSelector } from 'src/store'
import uiActions from 'src/store/ui/notification'
import styled from 'styled-components'

type Props = {
  onCharge: Function
}

const SquareForm = (props: Props) => {
  const { onCharge } = props
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.ui.app.authInfo)

  const status = useScript(APP_SQ_ENDPOINT_JS)
  const [card, setCard] = useState<any>(undefined)
  const [payments, setPayments] = useState<any>(undefined)
  const [loadingForm, setLoadingForm] = useState<boolean>(false)
  const [loadingPayment, setLoadingPayment] = useState<boolean>(false)

  useEffect(() => {
    if (status === 'ready') {
      initPage()
    }
  }, [status])

  const initPage = async () => {
    setLoadingForm(true)

    const square = (window as any).Square
    if (square) {
      const paymentsInstance = square.payments(
        SQ_APPLICATION_ID,
        SQ_LOCATION_ID,
      )
      const customCard = await paymentsInstance.card({
        style: {
          input: {
            color: '#000',
            backgroundColor: '#F1EFE7',
          },
          '.input-container': {
            borderColor: '#CFC392',
          },
          '.input-container.is-focus': {
            borderColor: '#CFC392',
          },
        },
      })
      await paymentsInstance.setLocale('ja-JP')
      await customCard.attach('#card-container')

      setCard(customCard)
      setPayments(paymentsInstance)
    }
    setLoadingForm(false)
  }

  const chargeSquare = async () => {
    if (!card || !payments) {
      return
    }
    setLoadingPayment(true)
    try {
      const tokenResult = await card.tokenize()
      if (tokenResult.status !== 'OK') {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: '正確なカード情報を入力してください。',
          }),
        )
        return
      }

      const resultCard = await payments.verifyBuyer(tokenResult.token, {
        intent: 'STORE',
        amount: '0',
        currencyCode: 'JPY',
        billingContact: {
          familyName: user?.family_name || '',
          givenName: user?.given_name || '',
          email: user?.email,
          countryCode: 'JP',
          phone: user?.phone,
          postalCode:
            tokenResult.details?.billing?.postalCode &&
            tokenResult.details.billing.postalCode,
        },
      })

      await onCharge({
        status: 'OK',
        token: tokenResult.token,
        verification_token: resultCard.token,
      })
    } catch (error) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message: '正確なカード情報を入力してください。',
        }),
      )
    } finally {
      setLoadingPayment(false)
    }
  }

  return (
    <Wrapper>
      {loadingForm && <Skeleton />}
      <div id="card-container"></div>
      <ButtonCustom
        onClick={chargeSquare}
        loading={loadingPayment}
        className="btn-default btn-chestnut-rose"
        htmlType="button"
        name="保存する"
        showIconRight
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 20px;
`

export default SquareForm
